// @flow

import type {Country} from 'docs/data';
import type {CountryRequestModel} from 'docs/types';

export const transformCountry = (model: CountryRequestModel): Country => ({
  code: model.code,
  name: model.name,
  beta: model.beta,
});
